var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state"},[_c('p',{staticClass:"empty-state__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"empty-state__subtitle"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }